import React from "react";
import { SelectDateTimeHeader } from "../selectedDateTimeHeader/SelectedDateTimeHeader";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { SelectedSlot } from "../selectedSlot/SelectedSlot";
import { SelectedCourt } from "../selectedCourt/SelectedCourt";
import { observer } from "mobx-react-lite";
import { useCourtBookingStore } from "../../stores/StoreContext";
import {
  formatDateToDifferenceText,
  getDateInYYYYMMDDFormat,
} from "../../utils/utils";
import { SpecificBookingSlot } from "../../apis/types";

type props = {};

export const SelectDateAndTimeCollapsed: React.FC<props> = observer(() => {
  const courtBookingStore = useCourtBookingStore();
  return (
    <div
      style={{
        backgroundColor: "white",
        marginRight: 20,
        marginLeft: 20,
        padding: 20,
        borderRadius: 20,
      }}>
      <SelectDateTimeHeader />
      <TCText
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: Colors.darkBrown,
          marginTop: 10,
        }}
        value={formatDateToDifferenceText(
          getDateInYYYYMMDDFormat(
            courtBookingStore.selectedDate?.fullDate ?? new Date()
          )
        )}
      />
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          scrollbarWidth: "none", // Hides scrollbar in Firefox
          msOverflowStyle: "none", // Hides scrollbar in IE
          whiteSpace: "nowrap", // Prevents wrapping
          marginTop: 2,
        }}>
        {courtBookingStore.selectedTimeSlots.map(
          (timeSlot: SpecificBookingSlot) => (
            <SelectedSlot
              key={timeSlot.startSlotTime}
              slot={timeSlot.slotName}
            />
          )
        )}
      </div>
      <SelectedCourt />
    </div>
  );
});
